import BaseApi from './baseApi';
import INotification from '../models/INotification';
import IAuthentication from '../models/IAuthentication';
export default class NotificationApi extends BaseApi {
    idUser : string = "";
    constructor() {
        super("notifications", "Dashboard");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
    }

    async SaveNotification(notification: INotification) : Promise<string> {
        const json = this.getJsonSave(notification);
        const response = await this.api.post('createnotification', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    private getJsonSave(notification: INotification) : any {
        const json = {
            "subject": notification.subject,
            "body": notification.body,
            "type": notification.type,
            "identifier": notification.identifier,
            "destinationCompany": notification.destinationCompany
        };
        return json;
    }
}
